import * as React from 'react';

import * as styles from './gridOneCol.module.scss';

interface GridOneColProps {
  align?: 'center' | 'left';
  border?: 'gray' | 'painted';
  children?: React.ReactNode;
  columnContent?: {
    primary: {
      border_color?: string;
      text_alignment?: string;
      rich_text_content: {
        html: string;
        text: string;
      };
      full_width_image?: {
        url: string;
      };
    };
  };
  gridType?: 'full' | 'small';
}

const GridOneCol: React.FC<GridOneColProps> = ({
  children,
  border,
  align,
  gridType,
  columnContent,
}) => {
  const randomInt = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
  let columnHtmlContent = null;
  let columnImageUrl = null;
  let style;

  if (columnContent) {
    columnImageUrl = columnContent.primary.full_width_image?.url;
    columnHtmlContent = columnContent.primary.rich_text_content;
    border = columnContent.primary.border_color
      ? (columnContent.primary.border_color.toLowerCase() as GridOneColProps['border']) // assume value from Prismic is valid
      : null;
    align = columnContent.primary.text_alignment
      ? (columnContent.primary.text_alignment.toLowerCase() as GridOneColProps['align']) // assume value from Prismic is valid
      : null;

    if (columnHtmlContent) {
      // Check that Prismic isn't returning empty HTML tags
      columnHtmlContent = columnHtmlContent.text
        ? columnHtmlContent.html
        : null;
    }
  }

  if (border === 'painted') {
    style = {
      backgroundPosition: `center ${randomInt * 10}%`,
    };
  }

  return (
    <section
      className={`${styles.wrapper} ${styles[align]} ${
        gridType ? styles[gridType] : ''
      }`}>
      <div className={`${styles.content} ${border ? null : styles.noBorder}`}>
        {border && <hr style={style} className={styles[border]} />}
        {columnHtmlContent && (
          <div
            dangerouslySetInnerHTML={{__html: columnHtmlContent as string}}
          />
        )}
        {columnImageUrl && (
          <img src={columnImageUrl} alt="" role="presentation" />
        )}
        {children}
      </div>
    </section>
  );
};

export default GridOneCol;
